module.exports = __webpack_public_path__ + "./Vid_pbw_e9f7a71441951533c4a62df6eef0d332.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Vid_pbw.png
// module id = 609
// module chunks = 0